import { Card, Col, Row } from "react-bootstrap";
import Table from "@enerex/unified-ui-react/Table";
import Div from "../../../components/Div";
import PageTitle from "../../../components/PageTitle/index";

export const StateServices = ({ fetchedData }) => {
  const stateServices = [
    {
      header: "State",
      accessorKey: "state",
    },
    {
      header: "Commodity",
      accessorKey: "commodityName",
    },
    {
      header: "Utilities",
      accessorFn: (row) =>
        (row.utilities || [])
          .map((utility) => utility.utilityName)
          .filter(Boolean)
          .join(", "),
      cell: ({ row }) => {
        const utilities = row.original.utilities || [];

        if (utilities.length === 0) {
          return <span className="text-muted">-</span>;
        }

        return (
          <span>
            {utilities
              .map((utility) => utility.utilityName)
              .filter(Boolean)
              .join(", ")}
          </span>
        );
      },
    },
  ];
  const { "States & Commodities": StateAndCommodities } = fetchedData;
  return (
    <span>
      <Div className="d-flex align-items-center justify-content-between">
        <PageTitle title={"States & Services"} />
      </Div>
      <Card className="">
        <Card.Body>
          <Row>
            <Col sm="12">
              {stateServices && (
                <Table
                  columns={stateServices}
                  data={StateAndCommodities || []}
                  enableSearch={false}
                  enablePagination={false}
                  enableHideColumns={false}
                  enableSorting
                  enableFilters={false}
                  enableSelection={false}
                  enablePaginateAll={false}
                  enableColumnVisibilityStorage={false}
                  enableGlobalFilterStorage={false}
                  enableUrlPagination={false}
                  noDataMessage="No states and services found"
                />
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </span>
  );
};
